import React, { useEffect, useState } from "react";
import API_KEY from "api/recommendations";
import DIRECTUS from "api/index";
import { Row, Col, Typography, Spin, Button, Skeleton, Breadcrumb } from "antd";
import Card from "components/Recommendations/Card";
import Filters from "./Filters";
import StickyBox from "react-sticky-box/dist/esnext";
import { useHistory, Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import Footer from "../Footer";
import { getUserPrefs } from "utils/localItems";
const { Title, Text } = Typography;
export default function BuyerList() {
  const [buyers, setBuyers] = useState([]);
  const [countries, setCountries] = useState([]);
  const [hsCodesData, setHsCodesData] = useState([]);
  const [selectedHsCode, setSelectedHsCode] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [from, setFrom] = useState(0);
  const [size, setSize] = useState(10);
  const [prospectIds, setProspectIds] = useState([]);
  const [fetchingProspects, setFetchingProspects] = useState(false);
  const [allProspects, setAllProspects] = useState([]);
  const [query, setQuery] = useState("");
  const minFob = getUserPrefs()?.min_fob;
  const maxFob = getUserPrefs()?.max_fob;
  const hsCodes = getUserPrefs()?.hs_code;

  // api call to get buyers
  useEffect(() => {
    setLoading(true);
    API_KEY.URL.post(
      `${API_KEY.path.recommend}?min_fob_in_INR=${minFob}&max_fob_in_INR=${maxFob}&from_=${from}&size_=${size}&search_query=${query}`,
      {
        hscodes: hsCodes,
        facets:
          selectedCountries.length > 0 || selectedHsCode.length > 0
            ? { buyer_country: selectedCountries, hscode: selectedHsCode }
            : {},
      }
    )
      .then((res) => {
        setLoading(false);
        setBuyers(res?.data?.hits.map((item) => item?._source));
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [from, size, selectedCountries,selectedHsCode, query]);

  // api call to get countries
  useEffect(() => {
    API_KEY.URL.post(
      `${API_KEY.path.getAllCountries}?min_fob=${minFob}&max_fob=${maxFob}`,
      hsCodes
    )
      .then((res) => {
        console.log("countries", res.data?.facets?.country?.buckets);

        // const shuffled = res?.data.sort(() => 0.5 - Math.random());
        setCountries(res.data?.facets?.country?.buckets);
        setHsCodesData(res.data?.facets?.hscode?.buckets);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // get all prospects
  useEffect(() => {
    setFetchingProspects(true);
    DIRECTUS.URL.get(DIRECTUS.path.prospects, {
      params: {
        fields: "importer_id,id",
      },
    })
      .then((res) => {
        setFetchingProspects(false);
        setProspectIds(res.data?.data.map((importer) => importer?.importer_id));
        setAllProspects(res.data?.data);
        fetchBuyers();
      })
      .catch((err) => {
        console.log("err", err);
        setFetchingProspects(false);
      });
  }, []);

  const fetchProspects = () => {
    DIRECTUS.URL.get(DIRECTUS.path.prospects, {
      params: {
        fields: "importer_id,id",
      },
    })
      .then((res) => {
        // setFetchingProspects(false);
        setProspectIds(res.data?.data.map((importer) => importer?.importer_id));
        setAllProspects(res.data?.data);
      })
      .catch((err) => {
        console.log("err", err);
        // setFetchingProspects(false);
      });
  };
  const fetchBuyers = () => {
    setLoading(true);
    API_KEY.URL.post(
      `${API_KEY.path.recommend}?min_fob_in_INR=${minFob}&max_fob_in_INR=${maxFob}&from_=${from}&size_=${size}`,
      {
        hscodes: hsCodes,
        facets: {},
      }
    )
      .then((res) => {
        setLoading(false);
        setBuyers(res?.data?.hits.map((item) => item?._source));
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  //handle view more
  const handleViewMore = () => {
    setFrom((state) => state + 10);
    setSize((state) => state + 10);
  };
  const handleShortlist = (isShortlisted, { id, country, title }) => {
    if (!isShortlisted) {
      const payload = {
        country: country,
        importer_id: id,
        name: title,
        manufacturer: JSON.parse(localStorage.getItem("org"))?.id,
      };

      DIRECTUS.URL.post(DIRECTUS.path.prospects, payload)
        .then((res) => {
          setProspectIds((state) => [...state, `${id}`]);
          fetchProspects();
        })
        .catch((err) => console.log("err", err));
    } else {
      const prospect = allProspects.filter(
        (prospect) => prospect?.importer_id === `${id}`
      )?.[0];

      DIRECTUS.URL.delete(`${DIRECTUS.path.prospects}/${prospect?.id}`)
        .then((res) => {
          setProspectIds((state) => state.filter((item) => item !== `${id}`));
          fetchProspects();
        })
        .catch((err) => console.log("err", err));
    }
  };

  return (
    <>
      <Row>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Recommendations</Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      <Row style={{ marginTop: "1em" }}>
        <Col span={6}>
          <StickyBox offsetTop={0} offsetBottom={0}>
            <Filters
              countries={countries}
              selectedCountries={selectedCountries}
              selectedProducts={selectedProducts}
              setSelectedCountries={setSelectedCountries}
              setSelectedProducts={setSelectedProducts}
              setQuery={setQuery}
              hsCodesData={hsCodesData}
              setSelectedHsCode={setSelectedHsCode}
              selectedHsCode={selectedHsCode}
            />
          </StickyBox>
        </Col>
        {loading ? (
          <Col span={18}>
            {" "}
            <Skeleton style={{ height: "100vh" }} active />
          </Col>
        ) : (
          <Col span={18}>
            <Row justify="space-between">
              <Col>
                <Title level={4}>Buyer Recommendations</Title>
              </Col>
              <Col style={{ paddingRight: 20 }}>
                {allProspects ? (
                  <Button
                    type="default"
                    size="large"
                    style={{
                      border: "1px solid #0B7764",
                      background: "#F0F8F6",
                      color: "#0B7764",
                    }}
                    onClick={() => history.push("/prospects")}
                  >
                    {allProspects?.length > 0
                      ? `View ${allProspects?.length} prospects`
                      : "View prospects"}
                  </Button>
                ) : (
                  <Skeleton.Button active />
                )}
              </Col>
            </Row>

            <Row >
              {fetchingProspects ? (
                <Skeleton active />
              ) : (
                buyers?.map((item,index) => (
                  <Col span={12} style={{ paddingRight: 20 }}>
                    <Card
                      bordered={true}
                      title={item?.buyer_name}
                      country={item?.buyer_country}
                      str2={item?.trading_partners}
                      btnName={
                        <Row align="middle" style={{ margin: 0, padding: 0 }}>
                          <Text style={{ color: "#0B7764" }}>View details</Text>{" "}
                          <MdKeyboardArrowRight size={20} />
                        </Row>
                      }
                      handleShortlist={handleShortlist}
                      isShortlisted={prospectIds.includes(
                        `${item?.importer_id}`
                      )}
                      onClick={() =>
                        history.push(`/buyer-details/${item?.importer_id}`)
                      }
                      str1={
                        typeof item?.dealing_cities === "object"
                          ? item?.dealing_cities?.[0]
                          : item?.dealing_cities?.[0]
                      }
                      id={item?.importer_id}
                      showShortlistButton={true}
                    />
                  </Col>
                ))
              )}
            </Row>
            {fetchingProspects ? <Skeleton active /> : <Row style={{ marginTop: "3.75em" }} justify="center">
             { buyers.length > 0 ? <Col span={6}>
                <Button
                  style={{ width: "100%" }}
                  onClick={() => handleViewMore()}
                  size="large"
                >
                  View More
                </Button>
              </Col>: <Title level={3}>No results found</Title>}
            </Row>
}
            <Row justify="center" style={{ marginTop: "3em" }}>
              <Col>
                <Footer />
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </>
  );
}
